import React from "react";

const HeadingBlock = ({config}) => {

    const level = config?.level || 1;
    const text = config?.text || "";

    const className =
        level === 1
            ? "text-2xl font-bold text-gray-900"
            : level === 2
                ? "text-xl font-bold text-gray-900"
                : "text-lg font-semibold text-gray-900";

    if (level === 1) {
        return <h1 className={className}>{text}</h1>;
    }

    if (level === 2) {
        return <h2 className={className}>{text}</h2>;
    }

    if (level === 3) {
        return <h3 className={className}>{text}</h3>;
    }

    return <h4 className={className}>{text}</h4>;
};

export default HeadingBlock;